
import React from 'react';
import { Users, DollarSign, School, Settings, Database, Lightbulb, BarChartHorizontal, Briefcase } from "lucide-react";
import NavGroup from './NavGroup';
import NavItem from './NavItem';
import { ExpandedGroups } from './types';

interface SidebarSectionsProps {
  expandedGroups: ExpandedGroups;
  toggleGroup: (group: keyof ExpandedGroups) => void;
  isActive: (path: string) => boolean;
  isCompact?: boolean;
}

const SidebarSections: React.FC<SidebarSectionsProps> = ({
  expandedGroups,
  toggleGroup,
  isActive,
  isCompact = false
}) => {
  return (
    <div className="space-y-0 pb-2">
      <NavGroup
        title="Investors"
        isExpanded={expandedGroups.investors}
        onToggle={() => toggleGroup('investors')}
      >
        <NavItem
          to="/investor-directory"
          icon={Database}
          isActive={isActive('/investor-directory')}
          isCompact={isCompact}
        >
          Investor Database
        </NavItem>
        <NavItem
          to="/investor-crm"
          icon={Users}
          isActive={isActive('/investor-crm')}
          isCompact={isCompact}
        >
          Investor CRM
        </NavItem>
      </NavGroup>

      <NavGroup
        title="Resources"
        isExpanded={expandedGroups.resources}
        onToggle={() => toggleGroup('resources')}
      >
        <NavItem
          to="/pitch-analyzer"
          icon={Lightbulb}
          isActive={isActive('/pitch-analyzer')}
          isCompact={isCompact}
        >
          Pitch Analyzer
        </NavItem>
        <NavItem
          to="/valuation-calculator"
          icon={DollarSign}
          isActive={isActive('/valuation-calculator')}
          isCompact={isCompact}
        >
          Valuation Calc
        </NavItem>
        <NavItem
          to="/financial-model-template"
          icon={BarChartHorizontal}
          isActive={isActive('/financial-model-template')}
          isCompact={isCompact}
        >
          Financial Models
        </NavItem>
      </NavGroup>

      <NavGroup
        title="Tools"
        isExpanded={expandedGroups.tools}
        onToggle={() => toggleGroup('tools')}
      >
        <NavItem
          to="/templates"
          icon={Database}
          isActive={isActive('/templates')}
          isCompact={isCompact}
        >
          Templates
        </NavItem>
        <NavItem
          to="/fundraising-stats"
          icon={BarChartHorizontal}
          isActive={isActive('/fundraising-stats')}
          isCompact={isCompact}
        >
          Fundraising Stats
        </NavItem>
        <NavItem
          to="/deal-room"
          icon={Briefcase}
          isActive={isActive('/deal-room')}
          isCompact={isCompact}
        >
          Deal Room
        </NavItem>
      </NavGroup>

      <NavGroup
        title="Training"
        isExpanded={expandedGroups.training}
        onToggle={() => toggleGroup('training')}
      >
        <NavItem
          to="/mastering-fundraising"
          icon={School}
          isActive={isActive('/mastering-fundraising')}
          isCompact={isCompact}
        >
          Mastering Fundraising
        </NavItem>
        <NavItem
          to="/financial-modeling"
          icon={DollarSign}
          isActive={isActive('/financial-modeling')}
          isCompact={isCompact}
        >
          Financial Modeling
        </NavItem>
        <NavItem
          to="/ma-strategies"
          icon={Lightbulb}
          isActive={isActive('/ma-strategies')}
          isCompact={isCompact}
        >
          M&A Strategies
        </NavItem>
        <NavItem
          to="/fundraising-videos"
          icon={Users}
          isActive={isActive('/fundraising-videos')}
          isCompact={isCompact}
        >
          Expert Videos
        </NavItem>
      </NavGroup>

      <NavGroup
        title="Account"
        isExpanded={expandedGroups.account}
        onToggle={() => toggleGroup('account')}
      >
        <NavItem
          to="/manage-subscription"
          icon={DollarSign}
          isActive={isActive('/manage-subscription')}
          isCompact={isCompact}
        >
          Subscription
        </NavItem>
        <NavItem
          to="/settings"
          icon={Settings}
          isActive={isActive('/settings')}
          isCompact={isCompact}
        >
          Settings
        </NavItem>
        <NavItem
          to="/get-help"
          icon={Lightbulb}
          isActive={isActive('/get-help')}
          isCompact={isCompact}
        >
          Help
        </NavItem>
        <NavItem
          to="/feedback"
          icon={Users}
          isActive={isActive('/feedback')}
          isCompact={isCompact}
        >
          Feedback
        </NavItem>
      </NavGroup>

      <NavGroup
        title="Company"
        isExpanded={expandedGroups.company}
        onToggle={() => toggleGroup('company')}
      >
        <NavItem
          to="/company"
          icon={Users}
          isActive={isActive('/company')}
          isCompact={isCompact}
        >
          Company Profile
        </NavItem>
      </NavGroup>
    </div>
  );
};

export default SidebarSections;
